import { Component } from '@angular/core';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-deprecated-url-error',
  templateUrl: './deprecated-url-error.component.html',
  styleUrls: ['./deprecated-url-error.component.scss'],
  imports: [CdsLanguageModule],
})
export class DeprecatedUrlErrorComponent {}
